export default function SpecialRoundup() {
  return (
    <section
      id="pandian"
      className="relative overflow-hidden py-14 md:py-20"
      aria-label="明星盘点特辑"
    >
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20collage%20of%20stage%20spotlights%20and%20awards%20trophies%20with%20warm%20gold%20confetti%2C%20elegant%20silhouettes%2C%20warm%20coral%20and%20deep%20charcoal%20tones%2C%20premium%20entertainment%20press%20aesthetic%2C%20moody%20and%20sophisticated&width=1600&height=800&seq=gossip-roundup-banner&orientation=landscape"
        alt="明星盘点特辑：聚光灯与奖杯的暖色舞台背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/30" />

      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-start px-4 md:px-6">
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-accent-500" />
          <span className="text-xs font-bold tracking-[0.25em] text-accent-300">FEATURE · 明星盘点</span>
        </div>
        <h2 className="max-w-2xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          这一年的高光与名场面，<br className="hidden md:block" />
          值得慢下来<b className="text-accent-400">盘一盘</b>
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-7 text-background-100/85 md:text-base">
          从爆款舞台到口碑综艺，从红毯配色到幕后较真，编辑部每季出一份明星八卦盘点，把最值得回看的瞬间整理成章。热门事件一网打尽，别让好内容悄悄溜走。
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          {['爆款舞台', '口碑综艺', '红毯造型', '幕后时刻', '深扒幕后'].map((t) => (
            <span
              key={t}
              className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur"
            >
              #{t}
            </span>
          ))}
        </div>
        <a
          href="#feed"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600"
        >
          查看本周明星盘点
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}